import style from "./PathCard.module.css";
import { useTranslation } from "react-i18next";

import Button from "@/ui/button/Button";
import Icon from "@/ui/icon/Icon";
import { padZero, secondsToHoursMinutes } from "@/utils/helpers";
import { useLocalized } from "@/i18n/useLocalized";

function PathCard({ path }) {
	const { t } = useTranslation();
	const l = useLocalized();

	return (
		<div className={style.card}>
			<div
				className={style.thumbnailHolder}
				style={{
					"--thumbnail": `url(${path.thumbnail})`,
				}}
			></div>
			<div className={style.info}>
				<div className={style.title}>
					<h3>{l(path, "name")}</h3>
				</div>
				<div className={style.details}>
					<div className={style.detail}>
						<div className={style.labelHolder}>
							<div className={style.icoHolder}>
								<Icon icon="fa-chalkboard" />
							</div>
							<div className={style.label}>
								{t("paths:stats.courseCount")}
							</div>
						</div>
						<div className={style.valueHolder}>
							<div className={style.value}>
								{padZero(path.course_count)}
							</div>
						</div>
					</div>

					<div className={style.detail}>
						<div className={style.labelHolder}>
							<div className={style.icoHolder}>
								<Icon icon="fa-layer-group" />
							</div>
							<div className={style.label}>
								{t("paths:stats.moduleCount")}
							</div>
						</div>
						<div className={style.valueHolder}>
							<div className={style.value}>
								{padZero(path.module_count)}
							</div>
						</div>
					</div>
					<div className={style.detail}>
						<div className={style.labelHolder}>
							<div className={style.icoHolder}>
								<Icon icon="fa-user" />
							</div>
							<div className={style.label}>
								{t("courses:landing.details.lecturers")}
							</div>
						</div>
						<div className={style.valueHolder}>
							<div className={style.value}>
								{padZero(path.lecturers.length)}
							</div>
							<div className={style.teachers}>
								{path.lecturers.slice(0, 4).map((lecturer) => (
									<img
										key={lecturer.name}
										src={lecturer.picture_url}
									></img>
								))}
								{path.lecturers.length > 4 && (
									<span>+{path.lecturers.length - 4}</span>
								)}
							</div>
						</div>
					</div>
					<div className={style.detail}>
						<div className={style.labelHolder}>
							<div className={style.icoHolder}>
								<Icon icon="fa-clock" />
							</div>
							<div className={style.label}>
								{t("courses:landing.sidebar.duration")}
							</div>
						</div>
						<div className={style.valueHolder}>
							<div className={style.value}>
								{secondsToHoursMinutes(path.duration)}
							</div>
						</div>
					</div>
				</div>
				<div className={style.footer}>
					<div className={style.pointsHolder}>
						{path.ects_credits != 0 && (
							<div className={style.points}>
								<span className={style.value}>
									{path.ects_credits}
								</span>
								<span className={style.valute}>
									<span>ECTS</span>
									<span>{t("paths:ects.points")}</span>
								</span>
							</div>
						)}
					</div>
					<Button
						className={style.btn}
						to={`/paths/${path.slug}`}
						type="border"
					>
						<span>{t("paths:card.learnMore")}</span>
						<Icon icon="fa-angles-right" iconType="fa-solid" />
					</Button>
				</div>
			</div>
		</div>
	);
}

export default PathCard;
